import Main from './Main'
import Lista from './components/ListaEmpresasReboque'
import Novo from './components/NovaEmpresaReboque'

export default [
  {
    path: 'empresa-reboque',
    name: 'config.empresa-reboque',
    component: Main,
    redirect: { name: 'config.empresa-reboque.list' },
    children: [
      {
        path: '/',
        name: 'config.empresa-reboque.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.empresa-reboque.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.empresa-reboque.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/empresa-reboque/routes.js